import React, { useState } from "react";
import Header from "../core/Header";
import Footer from "../core/Footer";

import herobridal from '../assets/nifika/hero-bridal.jpg';
import bridal7 from '../assets/nifika/bridal7.jpg';
import bridal7a from '../assets/nifika/bridal7a.jpg';
import bridal7b from '../assets/nifika/bridal7b.jpg';
import bridal1 from '../assets/nifika/bridal1.jpg';
import bridal1a from '../assets/nifika/bridal1a.jpg';
import bridal1b from '../assets/nifika/bridal1b.jpg';
import bridal8 from '../assets/nifika/bridal8.jpg';
import bridal8a from '../assets/nifika/bridal8a.jpg';
import bridal8b from '../assets/nifika/bridal8b.jpg';
import bridal2 from '../assets/nifika/bridal2.jpg';
import bridal2a from '../assets/nifika/bridal2a.jpg';
import bridal2b from '../assets/nifika/bridal2b.jpg';
import bridal3 from '../assets/nifika/bridal3.jpg';
import bridal3a from '../assets/nifika/bridal3a.jpg';
import bridal3b from '../assets/nifika/bridal3b.jpg';
import bridal9 from '../assets/nifika/bridal9.jpg';
import bridal9a from '../assets/nifika/bridal9a.jpg';
import bridal9b from '../assets/nifika/bridal9b.jpg';
import bridal11 from '../assets/nifika/bridal11.jpg';
import bridal11a from '../assets/nifika/bridal11a.jpg';
import bridal11b from '../assets/nifika/bridal11b.jpg';
import bridal4 from '../assets/nifika/bridal4.jpg';
import bridal4a from '../assets/nifika/bridal4a.jpg';
import bridal4b from '../assets/nifika/bridal4b.jpg';
import bridal5 from '../assets/nifika/bridal5.jpg';
import bridal5a from '../assets/nifika/bridal5a.jpg';
import bridal5b from '../assets/nifika/bridal5b.jpg';
import bridal12 from '../assets/nifika/bridal12.jpg';
import bridal12a from '../assets/nifika/bridal12a.jpg';
import bridal12b from '../assets/nifika/bridal12b.jpg';
import bridal14 from '../assets/nifika/bridal14.jpg';
import bridal14a from '../assets/nifika/bridal14a.jpg';
import bridal14b from '../assets/nifika/bridal14b.jpg';
import bridal15 from '../assets/nifika/bridal15.jpg';
import bridal15a from '../assets/nifika/bridal15a.jpg';
import bridal15b from '../assets/nifika/bridal15b.jpg';
import bridal16 from '../assets/nifika/bridal16.jpg';
import bridal16a from '../assets/nifika/bridal16a.jpg';
import bridal16b from '../assets/nifika/bridal16b.jpg';
import bridal17 from '../assets/nifika/bridal17.jpg';
import bridal17a from '../assets/nifika/bridal17a.jpg';
import bridal17b from '../assets/nifika/bridal17b.jpg';
import bridal18 from '../assets/nifika/bridal18.jpg';
import bridal18a from '../assets/nifika/bridal18a.jpg';
import bridal18b from '../assets/nifika/bridal18b.jpg';
import bridal13 from '../assets/nifika/bridal13.jpg';
import bridal13a from '../assets/nifika/bridal13a.jpg';
import bridal13b from '../assets/nifika/bridal13b.jpg';
import bridal6 from '../assets/nifika/bridal6.jpg';
import bridal6a from '../assets/nifika/bridal6a.jpg';
import bridal6b from '../assets/nifika/bridal6b.jpg';
import bridal19 from '../assets/nifika/bridal19.jpg';
import bridal19a from '../assets/nifika/bridal19a.jpg';
import bridal19b from '../assets/nifika/bridal19b.jpg';


const items = [
  // Page 1
  {
    image: bridal7,
    description: "Silk satin bias gown",
  },
  {
    image: bridal7a,
    description: "Calais Lace gown",
  },
  {
    image: bridal7b,
    description: "Silk organza bow",
  },
  {
    image: bridal1,
    description: "Silk satin bias gown",
  },
  {
    image: bridal1a,
    description: "Calais Lace gown",
  },
  {
    image: bridal1b,
    description: "Silk organza bow",
  },
  {
    image: bridal14,
    description: "Silk satin bias gown",
  },
  {
    image: bridal14a,
    description: "Calais Lace gown",
  },
  {
    image: bridal14b,
    description: "Silk organza bow",
  },
  {
    image: bridal8,
    description: "Silk satin bias gown",
  },
  {
    image: bridal8a,
    description: "Calais Lace gown",
  },
  {
    image: bridal8b,
    description: "Silk organza bow",
  },
  {
    image: bridal2,
    description: "Description",
  },
  {
    image: bridal2a,
    description: "Description",
  },
  {
    image: bridal2b,
    description: "Description",
  },
  {
    image: bridal15,
    description: "Description",
  },
  {
    image: bridal15a,
    description: "Description",
  },
  {
    image: bridal15b,
    description: "Description",
  },
  {
    image: bridal9,
    description: "Description",
  },
  {
    image: bridal9a,
    description: "Description",
  },
  {
    image: bridal9b,
    description: "Description",
  },
  {
    image: bridal3,
    description: "Description",
  },
  {
    image: bridal3a,
    description: "Description",
  },
  {
    image: bridal3b,
    description: "Description",
  },
  {
    image: bridal16,
    description: "Description",
  },
  {
    image: bridal16a,
    description: "Description",
  },
  {
    image: bridal16b,
    description: "Description",
  },
  // Page 2
  {
    image: bridal11,
    description: "Description",
  },
  {
    image: bridal11a,
    description: "Description",
  },
  {
    image: bridal11b,
    description: "Description",
  },
  {
    image: bridal4,
    description: "Description",
  },
  {
    image: bridal4a,
    description: "Description",
  },
  {
    image: bridal4b,
    description: "Description",
  },
  {
    image: bridal17,
    description: "Description",
  },
  {
    image: bridal17a,
    description: "Description",
  },
  {
    image: bridal17b,
    description: "Description",
  },
  {
    image: bridal12,
    description: "Description",
  },
  {
    image: bridal12a,
    description: "Description",
  },
  {
    image: bridal12b,
    description: "Description",
  },
  {
    image: bridal5,
    description: "Description",
  },
  {
    image: bridal5a,
    description: "Description",
  },
  {
    image: bridal5b,
    description: "Description",
  },
  {
    image: bridal18,
    description: "Description",
  },
  {
    image: bridal18a,
    description: "Description",
  },
  {
    image: bridal18b,
    description: "Description",
  },
  {
    image: bridal13,
    description: "Description",
  },
  {
    image: bridal13a,
    description: "Description",
  },
  {
    image: bridal13b,
    description: "Description",
  },
  {
    image: bridal6,
    description: "Description",
  },
  {
    image: bridal6a,
    description: "Description",
  },
  {
    image: bridal6b,
    description: "Description",
  },
  {
    image: bridal19,
    description: "Description",
  },
  {
    image: bridal19a,
    description: "Description",
  },
  {
    image: bridal19b,
    description: "Description",
  },
];


const Nifika = () => {

const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 27; 

const totalPages = Math.ceil(items.length / itemsPerPage);

const currentItems = items.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

const goToPage = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="overflow-x-hidden">

      <section className="relative h-screen  bg-no-repeat bg-cover bg-[center_40%]" style={{ backgroundImage: `url(${herobridal})` }}>
        <div className="absolute inset-0 bg-black bg-opacity-50"></div> {/* Overlay */}

          {/* Header */}
          <Header />
          
          <div className="relative z-10 h-full flex flex-col justify-center items-center text-white text-center px-4 pt-28">
            <h1 className="text-4xl md:text-4xl lg:text-5xl font-semibold uppercase tracking-wide mb-6">
              Bridal Collection
            </h1>
            <p className="text-lg md:text-xl max-w-3xl leading-relaxed mb-8 ">
            Στο Atelier Jenny σχεδιάζουμε και δημιουργούμε μοναδικά χειροποίητα Νυφικά φορέματα, ανταποκρινόμενα στις επιθυμίες σας, λαμβάνοντας υπόψιν την κάθε προσωπικότητα και σωματότυπο, αναδεικνύοντας τη θηλυκότητα, την κομψότητα, τη γοητεία και την ομορφιά.
            </p>
        </div>
      </section>

    <section className="p-10 bg-gray-100">
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
    {currentItems.map((item, index) => (
        <div
          key={index}
          className="text-center bg-white shadow-md  scale-90"
        >
          <img
            src={item.image}
            alt={item.description}
            className="w-full h-full object-cover"
          />
          <div className="p-4">
            {/* <p className="text-gray-600">{item.description}</p> */}
            <p className="text-gray-600"></p>
          </div>
        </div>
      ))}
    </div>

    <div className="mt-6 flex justify-center space-x-2">
        <button
          className={`px-4 py-2 bg-gray-200 rounded ${
            currentPage === 1 ? "cursor-not-allowed opacity-50" : ""
          }`}
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Προηγούμενη
        </button>

        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            className={`px-4 py-2 rounded ${
              currentPage === i + 1
                ? "bg-black text-white"
                : "bg-gray-200 text-gray-700"
            }`}
            onClick={() => goToPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}

        <button
          className={`px-4 py-2 bg-gray-200 rounded ${
            currentPage === totalPages ? "cursor-not-allowed opacity-50" : ""
          }`}
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Επόμενη
        </button>
      </div>

    </section>

    {/* Footer */}
    <Footer />

  </div>
  );
};

export default Nifika;
